import { Localytics } from '@gasbuddy/dom-telemetry';

export const CUSTOM_DIMENSIONS = {
  USER_ID: 14,
  USER_NAME: 15,
};

export default Localytics;
